
import {
  SessionProfileStatus,
  ProfileStatus,
} from "./../shared/models/manage-inventory.model";
import {
  Component,
  OnInit,
  Input,
  ViewEncapsulation,
  HostListener,
  Injectable,
  SimpleChanges,
  OnChanges,
  Output,
} from "@angular/core";
import { map, catchError } from "rxjs/operators";
import { StatusBarModel } from "lib/ng2-sapmp/src/ui-components/status-bar";
import { DEVICE_DEPLOYMENT_SUMMARY, CHART_CONFIG } from "config";
import {
  ManageInventoryService,
  FanSummary,
  FansDeviceSummary,
  DevicesSummary,
} from "./../shared";
import {
  UtilityService,
  AuthenticationService,
} from "lib/ng2-sapmp/src/providers";
import { BreadCrumbService } from "lib/ng2-sapmp/src/ui-components/breadcrumb";
import { PageLoaderService } from "lib/ng2-sapmp/src/ui-components/page-loader";
//import { GridOptionsModel, ColumnDefinitionsModel, PaginationsModel, FetchCriteriaModel, FilterService } from 'lib/ng2-sapmp/src/ui-components/custom-grid';
import {
  GridOptionsModel,
  ColumnDefinitionsModel,
  PaginationsModel,
  FetchCriteriaModel,
  FilterService,
  CustomGridExtendedComponent,
} from "lib/ng2-sapmp/src/ui-components/custom-grid-extended";
import { Router, ActivatedRoute } from "@angular/router";
import { deviceInventory } from "config";
import {
  AccordionComponent,
  AccordionModel,
  AccordionListComponent,
} from "lib/ng2-sapmp/src/ui-components/accordion";
import { ConfirmModalPopupModel } from "lib/ng2-sapmp/src/ui-components/confirm-modal";
import { MobilePivotModel } from "lib/ng2-sapmp/src/ui-components/mobile-pivot";
import { MOBILEPIVOTS } from "config";
import { SignupService } from "./../../signup/shared/providers/signup.service";
import { DomSanitizer } from "@angular/platform-browser";
import { DatePickerService } from "lib/ng2-sapmp/src/ui-components";
import { DevicesModel } from "app/pages/grouping-devices/model/grouping-devices.model";
import { AdobeAnalyticsService } from 'lib/ng2-sapmp/src/providers';//Added for accesories


declare var ENV_PORTAL:any;//Added for accesories
import { GroupingDevicesService } from '../../grouping-devices/grouping-devices.service';
import {IndexedDbService} from '../../../indexed-db.service';
// import { log } from "console";
// declare var ENV_PORTAL:any;//Added for accesories

@Component({
  selector: "app-device-inventory",
  templateUrl: "./device-inventory.component.html",
  styleUrls: ["./device-inventory.component.scss"],
  providers: [
    ManageInventoryService,
    SignupService,
    CustomGridExtendedComponent,
    FilterService,
    DatePickerService,
    AdobeAnalyticsService,//Added for accesories
    GroupingDevicesService,
    IndexedDbService
  ],
  encapsulation: ViewEncapsulation.None,
})
export class DeviceInventoryComponent implements OnInit {
  static SANITIZE;
  modalClass: string;
  leftLabel: string;
  rightLabel: string;
  progressChartData: Array<StatusBarModel>;
  singleFanInventory: any;
  gridOptions: GridOptionsModel;
  public enrollDatePopup: ConfirmModalPopupModel;
  options: Array<AccordionModel>;
  singleFanDetails: any = deviceInventory.singleFanDetail;
  supportArticles: any;
  initModal: Boolean = false;
  showSupport: Boolean = false;
  showError: boolean;
  smsSent: boolean;
  data: any;
  isMobile: boolean;
  content: string;
  deviceInventoryData: any;
  confirmModalPopup: ConfirmModalPopupModel;
  showPopup: boolean;
  popupHeading: any;
  popupContent: any;
  selectedFanId: any;
  overviewModalPopup: ConfirmModalPopupModel;
  showReportPopup: boolean;
  ctnTable: any;
  eventEmit: any;
  pivots: Array<MobilePivotModel>;
  permissions: any;
  enrolledCount: number;
  showLIC: boolean;
  article: any;
  title: any;
  mdmDetails: any;
  fanInfoList: any;
  accountIdlGoogle: string;
  accountIdSamsung: string;
  accountIdApple: string;
  deviceSummaryData: any;
  remainingPrograms: number = 0;
  kme: boolean;
  ztp: boolean;
  abm: boolean;
  enrollStatusArr: any;
  arialabel: string;
  oemStatus: boolean;
  oemNewScreen: boolean;
  addpAuthority: any;
  addpAllow: boolean;
  existingDate: string;
  formSuccess = false;
  failuremessage: boolean = false;
  showEnrollDetailsModal = false;
  showOverviewModal: boolean;
  videoId: string;
  helpArticles: any;
  supportArticle = false;
  pageSize: number;
  sessionProfileStatus: SessionProfileStatus;
  sizePerPage: number;
  presentDataSet: any;
  searchData: Array<ProfileStatus> = [];
  filterValue: string;
  showNotifyMsg: String;
  showNotifyError: boolean = false;
  showNewnotifyFailureError: boolean = false;
  showorgidsuccessMsg: String;
  showorgidFailError: boolean = false;
  showorgidsuccessmsg: boolean = false;
  ctnSelect: boolean = true;
  imeiSelect: boolean = false;
  customGridOptions = new GridOptionsModel();
  legendData: {};
  totalGroupCount: string;
  formSuccessGrp: boolean = false;
  countFlag: boolean = false;
  manageGroupFlag: boolean = false;
  public groupDeviceFlag: boolean = false;
  changebuttonABM: boolean;
  disableLinks: boolean = false;
  statusOptions: any = [];
  public defaultStatus = { name: "Select", value: "" };
  public defaultGroup = { name: "Select", value: "" };
  groupsOptions: any = [{ name: "Select", value: "" }];
  public pageJson;
  public ctn: any;
  public imei: any;
  public deviceModel: any;
  rowData: any = [];
  filterRowData: Array<DevicesModel>;
  public status: any;
  public group: any;
  selectedRowData: any = [];
  totalNumberOfRecords: number;
  public groupingDevicesDetails: any;
  isctnNumberInvalid: boolean;
  isimeiNumberInvalid: boolean;
  isModelInvalid: boolean;
  public numberOfRowsSelected: number;
  public showNumberOfRowsSelected: boolean = false;
  public numberPattern = new RegExp("^[0-9]*$");
  public modelPattern = new RegExp("^[0-9a-zA-Z-\\s]*$");
  db: any;
  indexedDBReq: any;
  public isPremier: boolean = false;//Added for accesories
  // profileAndPermsInfo: any;
  // ddo: any;

  @HostListener("window:resize", ["$event"])
  onResize(event) {
    this.mobileView();
  }

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private _sanitizer: DomSanitizer,
    private pageloaderService: PageLoaderService,
    private breadCrumbService: BreadCrumbService,
    private signupService: SignupService,
    private authenticationService: AuthenticationService,
    private FilterService: FilterService,
    private manageInventoryService: ManageInventoryService,
    private utilityService: UtilityService,
    private dateformatter: DatePickerService,
    private adobeAnalyticsService: AdobeAnalyticsService, //Added for accessories
    private groupingDevicesService: GroupingDevicesService,
    private dbService: IndexedDbService
  ) {
    DeviceInventoryComponent.SANITIZE = _sanitizer;
    this.leftLabel = "Devices";
    this.progressChartData = [];
    this.singleFanInventory = {};
    this.options = [];
    this.showError = false;
    this.smsSent = sessionStorage.getItem("smsSent") ? true : false;
    sessionStorage.removeItem("smsSent");
    this.checkFanId();
    const permission = sessionStorage.getItem("permissions");
    if (permission !== "null") {
      this.permissions = JSON.parse(permission);
    }
    
    // this.groupingDevicesService.openIndexedDB();
  }

  ngOnInit() {
    //document.title = this.utilityService.getPageTitleConfig()[this.router.routerState.snapshot.url];
    this.pivots = MOBILEPIVOTS.SINGLEFANDEVICEINVENTORY;
    sessionStorage.removeItem("CancelParticipationData");
    this.pageJson = this.route.snapshot.data.pageData.manageInventorydeviceInventory;
    this.statusOptions = this.pageJson.Status;
    this.showLIC =
      JSON.parse(sessionStorage.getItem("user")).user.roles === "LIC" &&
      sessionStorage.getItem("client") !== null &&
      sessionStorage.getItem("client").toUpperCase() === "UD";
    this.mdmDetails = JSON.parse(sessionStorage.getItem("mdmDetails"));
    this.addpAuthority = JSON.parse(
      sessionStorage.getItem("user")
    ).user.addpAuthority;
    if (this.addpAuthority === "PARTIAL") {
      this.addpAllow = false;
    }
    if (
      this.mdmDetails.productCode === "ADDPZTE" ||
      this.mdmDetails.productCode === "DMPAABM"
    ) {
      this.oemStatus = true;
      this.leftLabel = "Enrollment Status";
      this.singleFanDetails = deviceInventory.singleFanDetailOEM;
    } else {
      this.oemStatus = false;
    }
    //Added for accessories 
    if (ENV_PORTAL==='sapmp'||ENV_PORTAL==='dmpadmin')
    {
        this.isPremier=true;
    }

    const userObj = this.authenticationService.getUser();
    if (userObj) {
      let userName;
      if (
        (userObj.firstName.length == 0 || userObj.firstName == "NOT_FOUND") &&
        (userObj.lastName.length == 0 || userObj.lastName == "NOT_FOUND")
      ) {
        userName = "Unknown";
      } else if (
        userObj.firstName.length > 0 &&
        userObj.firstName != "NOT_FOUND" &&
        (userObj.lastName.length == 0 || userObj.lastName == "NOT_FOUND")
      ) {
        userName = userObj.firstName;
      } else if (
        (userObj.firstName.length == 0 || userObj.firstName == "NOT_FOUND") &&
        userObj.lastName.length > 0 &&
        userObj.lastName != "NOT_FOUND"
      ) {
        userName = userObj.lastName;
      } else {
        userName = userObj.firstName + " " + userObj.lastName;
      }
      document.getElementsByClassName("first-name")[0].innerHTML = userName;
    }

    this.pageloaderService.setPageLoaderStatus(false);
    //this.manageInventoryService.getDeviceInventoryContent(this.utilityService.getEnvConfig().contentUrl.manageInventory.deviceInventory).
    // subscribe(response => {
    this.deviceInventoryData =
      this.route.snapshot.data.pageData.manageInventorydeviceInventory;
    this.enrollDatePopup = new ConfirmModalPopupModel();
    this.enrollDatePopup.modalHeader =
      this.deviceInventoryData.enrollDatePopup.heading;
    if (!this.oemStatus) {
      this.enrollDatePopup.modalMessage =
        this.deviceInventoryData.enrollDatePopup.description;
    } else {
      this.enrollDatePopup.modalMessage =
        this.deviceInventoryData.enrollDatePopup.descriptionOem;
    }
    // tslint:disable-next-line:max-line-length
    this.enrollDatePopup.showCancelButton = false;
    // will be passing selected fan id as request;
    this.manageInventoryService
      .getSingleDevicesInventory([this.selectedFanId])
      .subscribe(
        (respobj) => {
          //4290
          console.log("respobj===>", respobj);
          let tempData = respobj.devicesSummary.filter(
            (x) => x.fan.status === "ACTIVE" || x.fan.status === "PROCESSING" || x.fan.status === "SIGNUP_INPROGRESS"
          );
          if (tempData.length == 2) {
            this.deviceSummaryData = tempData.reverse();
          }
            this.deviceSummaryData = tempData;
            this.remainingPrograms = 3 - this.deviceSummaryData.length;
          //4290
          let checkProcessFan = respobj.devicesSummary.filter(
            (x) => x.fan.emmProductCode === "DMPAABM" && (x.fan.status === "PROCESSING" || x.fan.status === "SIGNUP_INPROGRESS")
          );

          this.changebuttonABM = checkProcessFan.length > 0 ? true : false


          if (!this.utilityService.getEnvConfig().useMock) {
            this.data = this.deviceSummaryData[0];
          } else {
            this.data = respobj;
          }

          if (this.data.fan && this.data.fan.status) {
            this.singleFanInventory.fan = this.data.fan.fanId;
            this.singleFanInventory.profile = this.data.profile?.profileName;
            this.singleFanInventory.profileId = this.data.profile?.profileId;
            this.singleFanInventory.newDeviceEffectiveDate =
              this.data.fan.newDeviceEffectiveDate;
            this.singleFanInventory.existDeviceEffectiveDate =
              this.data.fan.existDeviceEffectiveDate;
            this.singleFanInventory.emmAccId = this.data.fan.emmAccountId;
            this.singleFanInventory.prodcode = this.data.fan.emmProductCode;
            //this.singleFanInventory.comPref = this.data.profile.communicationPref;
            //adding null condition.since existDeviceEffectiveDate coming as null

            if (!this.data.profile || this.data.profile.communicationPref === "Both" || this.data.profile.communicationPref === null) {
              this.singleFanInventory.comPref = "Email/Text";
            } else if (this.data.profile.communicationPref === "Sms") {
              this.singleFanInventory.comPref = "Text";
            } else if (this.data.profile.communicationPref === "Email") {
              this.singleFanInventory.comPref = "Email";
            }
            this.enrollStatusArr = [false, false, false];

            for (let k = 0; k < this.deviceSummaryData.length; k++) {
              if (
                this.deviceSummaryData[k].fan.existDeviceEffectiveDate === "" ||
                this.deviceSummaryData[k].fan.existDeviceEffectiveDate === null
              ) {
                this.enrollStatusArr[k] = true;
              }

              if (this.deviceSummaryData[k].fan.emmProductCode === "DMPSKME") {
                this.accountIdSamsung =
                  this.deviceSummaryData[k].fan.emmAccountId;
                this.kme = true;
              } else if (
                this.deviceSummaryData[k].fan.emmProductCode === "DMPGZTP"
              ) {
                this.accountIdlGoogle =
                  this.deviceSummaryData[k].fan.emmAccountId;
                this.ztp = true;
              } else if (
                this.deviceSummaryData[k].fan.emmProductCode === "DMPAABM"
              ) {
                this.accountIdApple =
                  this.deviceSummaryData[k].fan.emmAccountId;
                this.abm = true;
              }
            }
            if (
              this.data.fan.status === "ACTIVE" &&
              new Date(this.data.fan.newDeviceEffectiveDate) > new Date()
            ) {
              const summaryConfig = DEVICE_DEPLOYMENT_SUMMARY.FUTURE_DEPLOYMENT;
              this.singleFanInventory = Object.assign(
                {},
                this.singleFanInventory,
                summaryConfig
              );
            } else {
              const summaryConfig =
                DEVICE_DEPLOYMENT_SUMMARY[this.data.fan.status];
              this.singleFanInventory = Object.assign(
                {},
                this.singleFanInventory,
                summaryConfig
              );
            }
            this.getChartData(this.data.deviceStatusSummary);
          } else {
            const summaryConfig = !this.data.btnText
              ? DEVICE_DEPLOYMENT_SUMMARY["NO_RESULT"]
              : this.data;
            this.singleFanInventory = Object.assign(
              {},
              this.singleFanInventory,
              summaryConfig
            );
            this.getChartData(this.data.deviceStatusSummary);
          }
          console.log("deviceSummaryData===>", this.data);
          let enrollStatus = new Set(this.deviceSummaryData.map(elm => elm.fan.status));
          this.deviceInventoryData.navLinks.forEach((element) => {
            if ((this.deviceSummaryData.length == 1 && this.deviceSummaryData[0].fan.emmProductCode === 'DMPAABM' && (this.deviceSummaryData[0].fan.status == 'PROCESSING' || this.deviceSummaryData[0].fan.status == 'SIGNUP_INPROGRESS')) || (enrollStatus.has("INACTIVE") && enrollStatus.has("PROCESSING"))) {
              this.disableReportIconIfABMFEPending(element);
            } else {
              this.disableNavLinks(element);
            }
          });
          this.deviceInventoryData.navOEMLinks.forEach((element) => {
            if ((this.deviceSummaryData.length == 1 && this.deviceSummaryData[0].fan.emmProductCode === 'DMPAABM' && (this.deviceSummaryData[0].fan.status == 'PROCESSING' || this.deviceSummaryData[0].fan.status == 'SIGNUP_INPROGRESS')) || (enrollStatus.has("INACTIVE") && enrollStatus.has("PROCESSING"))) {
              this.disableReportIconIfABMFEPending(element);
            } else {
              this.disableNavLinks(element);
            }

          });
          this.breadCrumbService.setStaticBreadCrumbs(
            this.router.routerState.snapshot.url
          );
          if (this.singleFanInventory.fan) {
            this.breadCrumbService.setCurrentBreadCrumb({
              label:
                "Devices for foundation account   " +
                this.singleFanInventory.fan,
              routerLink: "manageInventory/deviceInventory",
            });
          } else {
            this.breadCrumbService.setCurrentBreadCrumb({
              label: "Devices for foundation account ",
              routerLink: "manageInventory/deviceInventory",
            });
          }
        },
        (error) => {
          this.handleError(error);
        }
      );

    this.initgrid();
    //  });
    const pageName = "deviceInventoryPage";
    this.helpArticles = [
      { id: 1, isActive: true, category: "Help", content: "" },
    ];
    //if (!this.oemStatus) {
    this.signupService
      .requestSupportContent(
        this.utilityService.getEnvConfig().getSupportDocument + pageName
      )
      .subscribe(
        (resp) => {
          this.article = resp.supportArticles;
          this.article.name = this.article.availableArticle[0].name;
          this.supportArticle = true;
        },
        (err) => {
          // this.handleError(err);
        }
      );
    // }
    this.options.push({
      id: 1,
      isActive: true,
      category: "Help",
      description: "",
      ariaLabel: {
        expand: "Show help",
        collapse: "Hide help",
      },
    });
    this.manageInventoryService.createPageLoadProperties(
      "DEVICE_INVENTORY",
      "DeviceInventory"
    );

    // this.getGroupingDevicesData();
    sessionStorage.setItem("callingURL", "/manageInventory/deviceInventory");

    // let deviceSessionTable = JSON.parse(sessionStorage.getItem("deviceInventoryTable"));
    let deviceSessionTable;
    this.dbService.getAllData('devices').then(data => {
      deviceSessionTable = data[0];
    });
    // JSON.parse(localStorage.getItem("groupDeviceTableData"));


    // let deviceSessionTabless = JSON.parse(sessionStorage.getItem("groupDeviceTableData"));


    // this.rowData = deviceSessionTabless.list;
    this.rowData = deviceSessionTable.list;
    sessionStorage.setItem("callingURL", "/manageInventory/deviceInventory");

    this.groupingDevicesDetails = JSON.parse(sessionStorage.getItem("deviceInventoryTable"));
    this.totalNumberOfRecords = deviceSessionTable.totalNumberOfRecords;
  }

  getDataFromIndexedDB(){
    this.dbService.getAllData('devices').then(data => {
      console.log(data);
      return data.length > 0 ? data[0] : [];
    });
  }

  // Helper function to convert month abbreviation to index
  getMonthIndex(month: string): number {
    const months = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    return months.findIndex((m) => m === month);
  }
  navigate(route) {
    const queryparams = {};
    if (route === "signup") {
      queryparams["tab"] = "revisedFanList";
      this.router.navigate([route], { queryParams: queryparams });
    } else if (route === "reports") {
      this.initReportPopupModal();
    } else if (route === "groupingDevices" && this.countFlag === true) {
      this.groupDeviceFlag = true;
      window.scrollTo(0, 0);
    } else {
      this.router.navigate([route], { queryParams: queryparams });
    }
  }

  getSupportContent(articleNumber) {
    if (this.article.availableArticle[articleNumber].type === "url") {
      this.initPopupModal(
        this.article.availableArticle[articleNumber].title,
        articleNumber
      );
    }
  }

  initPopupModal(modalName, articleNumber) {
    this.videoId = this.article.availableArticle[articleNumber].url;
    this.showOverviewModal = true;
  }

  closeOverviewModal() {
    this.showOverviewModal = false;
  }

  selectStatusOption(option) {
    this.status = option.value;
  }

  selectGroupOption(option) {
    this.group = option.value;
  }

  getFanStatusAndGroupsData(data) {
    // let listData: any = this.getDataFromIndexedDB(); //JSON.parse(localStorage.getItem('groupDeviceTableData'));
    //  backupData = JSON.parse(sessionStorage.getItem("backupCtns"));
    //this.dbService.getAllData('devices').then(data => {
      this.groupsOptions = [{ name: "Select", value: "" }];
      if(data && data.list){
        let groupSet = new Set();
        for (let i = 0; i < this.totalNumberOfRecords; i++) {
          groupSet.add(data.list[i].group);
        }
        console.log("group values:" + groupSet.values());
        for (const x of groupSet.values()) {
          this.groupsOptions.push({ name: x, value: x });
        }
      }
    //});
    
  }



  clearAll() {
    document.getElementById('ctnNumber')['value'] = '';
    document.getElementById('imei')['value'] = '';
    document.getElementById('deviceModel')['value'] = '';
    this.isctnNumberInvalid = false;
    this.isimeiNumberInvalid = false;
    this.isModelInvalid = false;

    this.showNumberOfRowsSelected = false;

    // for(let i=0; i<this.selectedRowData.length; i++){
    //   for(let j=0; j<this.rowData.length; j++){
    //       if(this.selectedRowData[i].ctnNumber == this.rowData[j].ctnNumber){
    //         this.rowData[j].selected = false;
    //       }
    //   }
    // }

    // this.getFanStatusAndGroupsData();

    this.initgrid();


    sessionStorage.setItem('selectedDevicesForGrouping', null);


    this.defaultGroup = { name: "Select", value: "" }
    this.defaultStatus = { name: "Select", value: "" }
    setTimeout(() => {
      this.selectStatusOption({ name: "Select", value: "" })
      this.selectGroupOption({ name: "Select", value: "" })
      this.searchDevices(0);
    }, 0);

  }

  checkPattern(event) {

    if (!this.numberPattern.test(document.getElementById('ctnNumber')['value'])) {
      this.isctnNumberInvalid = true;
    }
    else {
      this.isctnNumberInvalid = false;
    }

    if (!this.numberPattern.test(document.getElementById('imei')['value'])) {
      this.isimeiNumberInvalid = true;
    }
    else {
      this.isimeiNumberInvalid = false;
    }

    if (!this.modelPattern.test(document.getElementById('deviceModel')['value'])) {
      this.isModelInvalid = true;
    }
    else {
      this.isModelInvalid = false;
    }

  }

  showenroll() {
    this.showEnrollDetailsModal = true;
    this.eventEmit = document.activeElement;
  }
  closePopupModal(confirm) {
    this.showEnrollDetailsModal = false;
  }

  initgrid() {
    this.pageSize = this.utilityService.getEnvConfig().ctnPageSize;
    const pageNumber = 1;
    var sessionId = sessionStorage.getItem("sessionId");
    this.manageInventoryService
      // .getDeviceInventory(this.selectedFanId, this.pageSize, pageNumber)
      .getGroupDevicesData(this.selectedFanId, sessionId)
      .subscribe(
        (respobj) => {
          // localStorage.setItem(
          //   "groupDeviceTableData",
          //   JSON.stringify(respobj)
          // );
          // this.groupingDevicesService.saveRecordsToDB(respobj);
          this.dbService.clearData('devices');
          this.dbService.addData("devices", respobj);
          this.totalNumberOfRecords = respobj.totalNumberOfRecords;
          this.getFanStatusAndGroupsData(respobj);

          this.totalGroupCount = respobj.totalGroupCount;
          if (parseInt(this.totalGroupCount) === 0) {
            this.totalGroupCount = "0";
            this.countFlag = true;
          }
          if(parseInt(this.totalGroupCount) === 0 || respobj.list === null || respobj.list === undefined){
            this.pageloaderService.setPageLoaderStatus(true);
            respobj.list = [];
          }
          sessionStorage.setItem(
            "totalGroupCount",
            JSON.stringify(this.totalGroupCount)
          );

          this.ctnTable = respobj;

          // sessionStorage.setItem("deviceInventoryTable", JSON.stringify(respobj));
          // respobj = JSON.parse(sessionStorage.getItem("groupDeviceTableData"));

          //const options = new GridOptionsModel();
          this.customGridOptions.enableFiltering = true;
          this.customGridOptions.enableSorting = true;
          this.customGridOptions.multiSelect = false;
          const pagination = {
            recordsPerPage: 100,
            currentPage: 1,
            isServerSide: false,
            totalRecords: respobj.totalNumberOfRecords,
            hideGoToPage: true,
          };
          // const paginationnew = {
          //   recordsPerPage: 15,
          //   currentPage: 1,
          //   isServerSide: true,
          //   totalRecords: respobj.totalNumberOfRecords,
          //   hideGoToPage: true
          // }
          let backupData: Array<SessionProfileStatus> = [];
          this.sessionProfileStatus = new SessionProfileStatus(1, respobj.list);
          this.searchData = respobj.list.map((el) => {
            el.groupName = el.group;
          });
          this.searchData = respobj.list;
          backupData.push(this.sessionProfileStatus);
          this.setToSessionCtns(backupData);
          sessionStorage.setItem("totalCtns", pagination.totalRecords);
          // if(this.oemStatus) {
          // sessionStorage.setItem('totalCtns', pagination.totalRecords);
          // }else{
          //   sessionStorage.setItem('totalCtns', paginationnew.totalRecords);
          // }
          this.customGridOptions.enableBackLink = true;
          this.customGridOptions.backLinkText =
            this.deviceInventoryData.backLinkText;
          this.customGridOptions.emptyMessage =
            this.deviceInventoryData.emptyMessage;
          this.customGridOptions.searchPlaceHolder = this.ctnSelect
            ? this.deviceInventoryData.searchPlaceHolder
            : this.deviceInventoryData.searchPlaceHolder1;
          this.customGridOptions.ariaLabel = this.ctnSelect
            ? this.deviceInventoryData.searchPlaceHolder
            : this.deviceInventoryData.searchPlaceHolder1;
          if (this.oemStatus) {
            this.customGridOptions.callbacks = {
              callBackAppNameCellTemplate: this.callBackAppNameCellTemplate,
              callBackProfileStatusoem: this.callBackProfileStatusoem,
              callBackImei: this.callBackImei,
            };
          } else {
            this.customGridOptions.callbacks = {
              callBackAppNameCellTemplate: this.callBackAppNameCellTemplate,
              callBackProfileStatus: this.callBackProfileStatus,
              callBackImei: this.callBackImei,
            };
          }
          this.customGridOptions.Paginations = pagination;
          this.customGridOptions.gridData = respobj.list;
          // this.sessionProfileStatus.sessionCtns.slice(
          //   0,
          //   pagination.recordsPerPage
          // );
          // if(this.oemStatus) {
          // options.Paginations = paginationnew;
          // options.gridData = this.sessionProfileStatus.sessionCtns.slice(0, paginationnew.recordsPerPage);
          // }else{
          //   options.Paginations = pagination;
          //   options.gridData = this.sessionProfileStatus.sessionCtns.slice(0, pagination.recordsPerPage);
          // }
          //options.gridData = respobj.list;

          //this.customGridOptions.maxLength = 12;
          this.customGridOptions.columnDefinitions =
            this.singleFanDetails.columnDefinitions;
          this.customGridOptions.searchDescriptions = "";
          // this.customGridOptions.ctnMask = true;
          this.customGridOptions.ctnMask = this.ctnSelect ? true : false;
          this.customGridOptions.imeiMask = this.imeiSelect ? true : false;
          this.customGridOptions.maxLength = this.ctnSelect ? 12 : 15;
          this.customGridOptions.disableGrid = false;
          this.customGridOptions.disableRow = false;
          this.customGridOptions.disableRowCondition = { field: "", value: "" };

          // refine grid data for "Claimed_Android"
          this.customGridOptions.gridData.map(function (x) {
            if (x.status == "Claimed_Android") {
              x.status = "Claimed_Android™";
            }
            if (x.status == "CLAIM_PENDING_Android") {
              x.status = "CLAIM_PENDING_Android™";
            }
          });

          this.gridOptions = this.customGridOptions;

          this.pageloaderService.setPageLoaderStatus(true);
          return this.gridOptions;
        },
        (error) => {
          this.handleError(error);
        }
      );
  }

  async searchDevices(data) {
    
    // let deviceSessionTable1 = JSON.parse(sessionStorage.getItem("deviceInventoryTable"));
    //let deviceSessionTable1: any = await this.getDataFromIndexedDB(); //JSON.parse(localStorage.getItem("groupDeviceTableData"));
    // let deviceSessionTabless = JSON.parse(sessionStorage.getItem("groupDeviceTableData"));

    // this.rowData = deviceSessionTabless.list;
    this.pageloaderService.setPageLoaderStatus(false);
    this.dbService.getAllData('devices').then(data => {
      // console.log(data);
      this.rowData = data[0].list.map((el) => {
        el.groupName = el.group;
      });
  
      this.rowData = data[0].list;
      this.filterRowData = this.rowData;
  
      let filteredData_ = this.filterRowData.map((x) => {
        if (x.status == "Claimed_Android") {
          x.status = "Claimed_Android™";
        }
        if (x.status == "CLAIM_PENDING_Android") {
          x.status = "CLAIM_PENDING_Android™";
        }
        return x;
      });
  
      for (let i = 0; i < this.selectedRowData.length; i++) {
        for (let j = 0; j < this.rowData.length; j++) {
          if (this.selectedRowData[i].ctnNumber == this.rowData[j].ctnNumber) {
            this.rowData[j].selected = false;
          }
        }
      }
      this.showNumberOfRowsSelected = false;
  
      console.log("Before search filterRowData:::::::::::::::::::::::: " + this.filterRowData);
  
      this.ctn = document.getElementById('ctnNumber')['value'];
      this.imei = document.getElementById('imei')['value'];
  
  
      this.deviceModel = document.getElementById('deviceModel')['value'];
  
      if (data) {
        if (this.ctn) {
          this.filterRowData = this.filterRowData.filter(item => item.ctnNumber.includes(this.ctn));
        }
        if (this.imei) {
          this.filterRowData = this.filterRowData.filter(item => item.imei.includes(this.imei));
  
        }
        if (this.deviceModel) {
          this.filterRowData = this.filterRowData.filter(item => item.model.toUpperCase().includes(this.deviceModel.toUpperCase()));
        }
        if (this.status) {
          if(this.status == "Claimed_Android™"){
            this.filterRowData = this.filterRowData.filter(item => item.status == "Claimed_Android" || item.status == "Claimed_Android™");
          }else if(this.status == "CLAIM_PENDING_Android™"){
            this.filterRowData = this.filterRowData.filter(item => item.status == "CLAIM_PENDING_Android" || item.status == "CLAIM_PENDING_Android™");
          }else if(this.status == "UNCLAIM_PENDING_Android™"){
            this.filterRowData = this.filterRowData.filter(item => item.status == "UNCLAIM_PENDING_Android" || item.status == "UNCLAIM_PENDING_Android™");
          }else{
            this.filterRowData = this.filterRowData.filter(item => item.status === this.status);
          }
        }
        if (this.group) {
          this.filterRowData = this.filterRowData.filter(item => item.group === this.group);
        }
      }
      if (this.filterRowData && this.filterRowData.length === 0) {
        this.showNumberOfRowsSelected = false;
      }
      console.log("After search filterRowData:::::::::::::::::::::::: " + this.filterRowData);
      console.log("After search filterRowData size:::::::::::::::::::::::: " + this.filterRowData.length);
  
      this.totalNumberOfRecords = this.filterRowData.length
      this.gridOptions = new GridOptionsModel;
      this.customGridOptions.gridData = this.filterRowData;
      this.customGridOptions.Paginations.currentPage = 1;
      this.customGridOptions.Paginations.totalRecords = this.customGridOptions.gridData.length;
      if (this.customGridOptions.gridData.length == 0) {
        this.customGridOptions.multiSelect = false;
        this.customGridOptions.isEmptyMessageInRow = false;
      } else {
        this.customGridOptions.multiSelect = false;
      }
  
      this.gridOptions = Object.assign({}, this.customGridOptions);
      setTimeout(() => {this.pageloaderService.setPageLoaderStatus(true);}, 2000);
      //this.gridOptions = JSON.parse(JSON.stringify(this.customGridOptions)); 
    });

    
  }

  onRowClickFunc(action) {
    var selectedDevicesForGrouping = this.rowData.filter(item => item.selected === true);
    this.numberOfRowsSelected = selectedDevicesForGrouping.length;
    if (this.numberOfRowsSelected > 0) {
      this.showNumberOfRowsSelected = true;
    } else {
      this.showNumberOfRowsSelected = false;
    }
    sessionStorage.setItem('selectedDevicesForGrouping', JSON.stringify(selectedDevicesForGrouping));
    console.log(selectedDevicesForGrouping);
    this.selectedRowData = selectedDevicesForGrouping;
  }

  gridEventChanges(fetchCriteria: FetchCriteriaModel) {
    if (fetchCriteria.searchValue) {
      this.calculateSearch(fetchCriteria);
    } else {
      let startRange: number;
      let flag = false;
      let backupData: Array<SessionProfileStatus> = [];
      this.sizePerPage = this.gridOptions.Paginations.recordsPerPage;
      let pageNumber = fetchCriteria.offset / this.sizePerPage + 1;
      const dataPerSet = Math.ceil(this.pageSize / fetchCriteria.limit);
      let requiredSet = Math.ceil(
        (fetchCriteria.offset + fetchCriteria.limit) / this.pageSize
      );
      // If offset reaches beyond the pageSize
      if (fetchCriteria.offset >= this.pageSize) {
        startRange = fetchCriteria.offset % this.pageSize;
      } else {
        startRange = fetchCriteria.offset;
      }
      if (requiredSet === this.sessionProfileStatus.setNo) {
        this.presentDataSet = this.sessionProfileStatus.sessionCtns.slice(
          startRange,
          startRange + this.sizePerPage
        );
        this.computeGrid(pageNumber);
      }
      // If required data is not available in sessionProfileStatus but available in sessionStorage or Backend
      else {
        // If required data is available in sessionStorage
        backupData = JSON.parse(sessionStorage.getItem("backupCtns"));
        backupData.forEach((element) => {
          if (element.setNo === requiredSet) {
            this.sessionProfileStatus = new SessionProfileStatus(
              requiredSet,
              element.sessionCtns
            );
            this.presentDataSet = this.sessionProfileStatus.sessionCtns.slice(
              startRange,
              startRange + this.sizePerPage
            );
            flag = true;
            this.gridOptions.Paginations.totalRecords = JSON.parse(
              sessionStorage.getItem("totalCtns")
            );
            this.computeGrid(pageNumber);
          }
        });
        // If required data is  not available in model and session then Backend Hit
        if (!flag) {
          this.pageloaderService.setPageLoaderStatus(false);
          this.manageInventoryService
            .getDeviceInventory(this.selectedFanId, this.pageSize, requiredSet)
            .toPromise()
            .then((respObj) => {
              this.pageloaderService.setPageLoaderStatus(true);
              this.sessionProfileStatus = new SessionProfileStatus(
                requiredSet,
                respObj.list
              );
              //
              respObj.list.forEach((element) => {
                this.searchData.push(element);
              });
              //
              //this.searchData.concat(respObj.list);
              backupData = JSON.parse(sessionStorage.getItem("backupCtns"));
              backupData.push(this.sessionProfileStatus);
              this.setToSessionCtns(backupData);
              this.presentDataSet = this.sessionProfileStatus.sessionCtns.slice(
                startRange,
                startRange + this.sizePerPage
              );
              this.computeGrid(pageNumber);
            })
            .catch((error) => this.handleError(error));
        }
      }
    }
  }

  calculateSearch(fetchCriteria: FetchCriteriaModel) {
    if (fetchCriteria.offset) {
      // For pagination for search data
      let pageNumber = fetchCriteria.offset / this.sizePerPage + 1;
      this.presentDataSet = this.sessionProfileStatus.sessionCtns.slice(
        fetchCriteria.offset,
        fetchCriteria.offset + this.sizePerPage
      );
      this.computeGrid(pageNumber);
    } else {
      // For the first search
      let filterColumns = [fetchCriteria.filteredCols];
      if (fetchCriteria.filteredCols === "imei") {
        this.sessionProfileStatus = new SessionProfileStatus(
          0,
          this.FilterService.getFilteredData(
            this.searchData,
            fetchCriteria.searchValue,
            ["imei"]
          )
        );
        // if(this.sessionProfileStatus.sessionCtns.length === 0){
        //   this.sessionProfileStatus = new SessionProfileStatus(0,this.FilterService.getFilteredData(this.searchData, fetchCriteria.searchValue, ["complianceStatus"]));
        // }

        let appendStatus = new SessionProfileStatus(
          0,
          this.FilterService.getFilteredData(
            this.searchData,
            fetchCriteria.searchValue,
            ["complianceStatus"]
          )
        );

        for (
          let i: number = 0;
          appendStatus.hasOwnProperty("sessionCtns") &&
          i < appendStatus.sessionCtns.length;
          i++
        ) {
          this.sessionProfileStatus.sessionCtns.push(
            appendStatus.sessionCtns.pop()
          );
        }

        let tempArr = this.sessionProfileStatus.sessionCtns.filter(
          (c, index) => {
            return this.sessionProfileStatus.sessionCtns.indexOf(c) === index;
          }
        );

        this.sessionProfileStatus.sessionCtns = tempArr;
      } else {
        this.sessionProfileStatus = new SessionProfileStatus(
          0,
          this.FilterService.getFilteredData(
            this.searchData,
            fetchCriteria.searchValue,
            filterColumns
          )
        );
      }
      this.presentDataSet = this.sessionProfileStatus.sessionCtns.slice(
        0,
        this.sizePerPage
      );
      this.gridOptions.Paginations.totalRecords =
        this.sessionProfileStatus.sessionCtns.length;
      this.computeGrid(1);
    }
  }

  computeGrid(pageNumber) {
    const tempOptions = this.gridOptions;
    this.gridOptions = new GridOptionsModel();
    tempOptions.Paginations.currentPage = pageNumber;
    tempOptions.gridData = this.presentDataSet;
    this.gridOptions = Object.assign({}, tempOptions);
  }

  ngOnDestroy() {
    sessionStorage.removeItem("backupCtns");
    sessionStorage.removeItem("totalCtns");
    this.dbService.closeConnection();
  }

  setToSessionCtns(sessionProfileStatus: Array<SessionProfileStatus>) {
    sessionStorage.setItem("backupCtns", JSON.stringify(sessionProfileStatus));
  }

  callBackImei(element, row, field, currentElem, type, col) {
    let imei = row.imei;
    let imei2 = row.complianceStatus;
    if (
      imei2 == "Unknown" ||
      imei2 === undefined ||
      imei2 === "" ||
      imei2 === null
    ) {
      return `<span class="imei1">${imei}</span>`;
    } else {
      return `<span class="imei1">${imei}</span><p class="imei2">${imei2}</p>`;
    }
  }

  /*add two cell for link of CTN and username */
  callBackAppNameCellTemplate(element, row, field, currentElem, type, col) {
    if (type === "template") {
      if (
        row.ctnNumber == null ||
        row.ctnNumber == "" ||
        row.ctnNumber == "Unknown"
      ) {
        const formatctnNumber = "Unknown";
        return ` <span class='ctn-imei'>${row.imei}</span><br/><span class='ctn-imei'>${formatctnNumber}</span>`;
      } else {
        const formatctnNumber = /^\d+$/.test(row.ctnNumber)
          ? row.ctnNumber.replace(/^(\d{0,3})(\d{0,3})(.*)/, "$1.$2.$3")
          : row.ctnNumber;
        const formatIMEI = row.imei;
        // .replace(
        //   /^(\d{0,3})(\d{0,3})(.*)/,
        //   "$1.$2.$3"
        // );
        const formatIMEI2 = row.complianceStatus;
        // .replace(
        //   /^(\d{0,3})(\d{0,3})(.*)/, 
        //   "$1.$2.$3"
        // );
        return ` <span class='ctn-imei'>${formatIMEI}</span><br/>
                 <span class='ctn-imei'>${formatctnNumber}</span>`;
      }
    } 
    else if (type.target.classList.contains("ctn-number")) {
      currentElem.onDataChange.emit({ data: row, type: "ctnInfo" });
    }
    else if (type.target.classList.contains("imei")) {
      currentElem.onDataChange.emit({ data: row, type: "imeiInfo" });
    }
  }
  /*add two cell for status updated in grid column */

  /*add two cell for status updated in grid column */
  callBackProfileStatus(element, row, field, currentElem) {
    const colorStatus = row.status.replace(/_/g, "-").toLowerCase();
    let status = row.status.replace(/_/g, " ");
    if (status === "ENROLLED ACTIVE") {
      status = "Enrolled, active";
    } else if (status === "OUT OF COMPLIANCE") {
      status = "Not compliant";
    } else if (status === "ENROLLED NOT ACTIVE") {
      status = "Enrolled, not active";
    } else if (status === "NOT ENROLLED") {
      status = "Not enrolled";
    } else if (status === "Claimed Android™") {
      status = "claimed (Android™)";
    } else if (status === "Claimed Android") {
      status = "claimed (Android™)";
    } else if (status === "Claimed Samsung") {
      status = "claimed (Samsung)";
    } else if (status === "Claimed Apple") {
      status = "claimed (Apple)";
    } else if (status === "UNCLAIM PENDING Android™") {
      status = "unclaim pending (Android™)";
    } else if (status === "UNCLAIM PENDING Android") {
      status = "unclaim pending (Android™)";
    } else if (status === "UNCLAIM PENDING Samsung") {
      status = "unclaim pending (Samsung)";
    } else if (status === "UNCLAIM PENDING Apple") {
      status = "unclaim pending (Apple)";
    } else if (status === "CLAIM PENDING Android™") {
      status = "claim pending (Android™)";
    } else if (status === "CLAIM PENDING Android") {
      status = "claim pending (Android™)";
    } else if (status === "CLAIM PENDING Samsung") {
      status = "claim pending (Samsung)";
    } else if (status === "CLAIM PENDING Apple") {
      status = "claim pending (Apple)";
    } else if (status === "Not Claimed") {
      status = "not claimed";
    } else if (status === "UNCLAIM PENDING") {
      status = "unclaim pending";
    } else if (status === "CLAIM PENDING") {
      status = "claim pending";
    }
    return `<div class="gridText" > <span class='${colorStatus} color-square custumgrid-field'></span><span class="custumgrid-field-status">${status}</span> </div>`;
  }
  callBackProfileStatusoem(element, row, field, currentElem) {
    const colorStatus = row.status.replace(/_/g, "-").toLowerCase();
    let status = row.status.replace(/_/g, " ");
    if (status === "ENROLLED ACTIVE") {
      status = "Enrolled";
    } else if (status === "OUT OF COMPLIANCE") {
      status = "Not compliant";
    } else if (status === "ENROLLED NOT ACTIVE") {
      status = "Enrolled";
    } else if (status === "NOT ENROLLED") {
      status = "Not enrolled";
    } else if (status === "Claimed Android™") {
      status = "claimed (Android™)";
    } else if (status === "Claimed Android") {
      status = "claimed (Android™)";
    } else if (status === "Claimed Samsung") {
      status = "claimed (Samsung)";
    } else if (status === "Claimed Apple") {
      status = "claimed (Apple)";
    } else if (status === "UNCLAIM PENDING Android™") {
      status = "unclaim pending (Android™)";
    } else if (status === "UNCLAIM PENDING Android") {
      status = "unclaim pending (Android™)";
    } else if (status === "UNCLAIM PENDING Samsung") {
      status = "unclaim pending (Samsung)";
    } else if (status === "UNCLAIM PENDING Apple") {
      status = "unclaim pending (Apple)";
    } else if (status === "CLAIM PENDING Android™") {
      status = "claim pending (Android™)";
    } else if (status === "CLAIM PENDING Android") {
      status = "claim pending (Android™)";
    } else if (status === "CLAIM PENDING Samsung") {
      status = "claim pending (Samsung)";
    } else if (status === "CLAIM PENDING Apple") {
      status = "claim pending (Apple)";
    } else if (status === "Not Claimed") {
      status = "not claimed";
    } else if (status === "UNCLAIM PENDING") {
      status = "unclaim pending";
    } else if (status === "CLAIM PENDING") {
      status = "claim pending";
    }
    return `<div class="gridText" > <span class='${colorStatus} color-square custumgrid-field'></span><span class="custumgrid-field-status">${status}</span> </div>`;
  }

  onRowClick(action) {
    if (action.type === "ctnInfo") {
      if (
        action.data.ctnNumber === "Unknown" ||
        action.data.ctnNumber === "" ||
        action.data.ctnNumber === null
      ) {
        this.manageInventoryService.setSelectedImei(action.data.imei);
      } else {
        this.manageInventoryService.setSelectedCtn(action.data.ctnNumber);
      }
      //this.manageInventoryService.setSelectedCtn(action.data.ctnNumber);
      sessionStorage.setItem("ctnDetails", JSON.stringify(action.data));
      sessionStorage.getItem("ProfileID")
        ? sessionStorage.removeItem("ProfileID")
        : null;
      sessionStorage.setItem("ProfileID", this.singleFanInventory.profileId);
      this.router.navigate(["manageInventory/ctnInfo"]);
    }
    if (action.type === "ctnInfo") {
      if (
        action.data.imei === "Unknown" ||
        action.data.imei === "" ||
        action.data.imei === null
      ) {
        this.manageInventoryService.setSelectedImei(action.data.imei);
      } 
      // else {
      //   this.manageInventoryService.setSelectedCtn(action.data.ctnNumber);
      // }
      //this.manageInventoryService.setSelectedCtn(action.data.ctnNumber);
      sessionStorage.setItem("imeiDetails", JSON.stringify(action.data));
      sessionStorage.getItem("ProfileID")
        ? sessionStorage.removeItem("ProfileID")
        : null;
      sessionStorage.setItem("ProfileID", this.singleFanInventory.profileId);
      this.router.navigate(["manageInventory/ctnInfo"]);
    }
  }

  /*check mobile view for support article accordion*/
  mobileView() {
    this.isMobile = window.innerWidth < 1024;
    this.supportArticles = [
      {
        id: 1,
        isActive: !this.isMobile,
        category: "Support articles",
        content: "",
      },
    ];
  }

  /*get chart data & integrate with status bar */
  getChartData(deviceDetails) {
    let totalValue = 0;
    this.mdmDetails = JSON.parse(sessionStorage.getItem("mdmDetails"));
    this.legendData = { left: [], right: [] };
    if (this.mdmDetails.productCode === "ADDPZTE") {
      this.arialabel =
        "Status bar showing the number of devices claimed compared to the total number of devices.";
    }
    if (deviceDetails && deviceDetails.length > 0) {
      deviceDetails.forEach((d) => {
        if (d.noOfDevices > 0 && d.noOfDevices !== null) {
          totalValue += d.noOfDevices;
          const chartConfig = CHART_CONFIG[d.status];
          // if (chartConfig.label === 'not claimed') {
          //     chartConfig.label = 'Not claimed';
          // }
          const temp: StatusBarModel = {
            value: d.noOfDevices,
            color: chartConfig.color,
            legend: d.noOfDevices + " " + chartConfig.label,
            ariaLabel: this.arialabel,
          };
          this.progressChartData.push(temp);
          if (d.status === "ENROLLED_ACTIVE") {
            this.enrolledCount = d.noOfDevices;
          }
        }
      });

      let count = 0;
      let tempChartData = [];
      tempChartData = this.progressChartData.filter(function (x, i) {
        if (
          x.value > 0 &&
          (x.legend.indexOf("claimed (Apple)") > -1 ||
            x.legend.indexOf("claimed (Samsung)") > -1 ||
            x.legend.indexOf("claimed (Android™)") > -1 ||
            x.legend.indexOf("claimed (Android)") > -1)
        ) {
          count += x.value;
        }

        return (
          x.value > 0 &&
          x.legend.indexOf("claimed (Apple)") <= -1 &&
          x.legend.indexOf("claimed (Samsung)") <= -1 &&
          x.legend.indexOf("claimed (Android™)") <= -1 &&
          x.legend.indexOf("claimed (Android)") <= -1
        );
      });

      this.progressChartData = tempChartData;
      if (count > 0) {
        const chartConfigClaim = CHART_CONFIG["CLAIM_SUCCESS"];
        const claimMerge: StatusBarModel = {
          value: count,
          color: chartConfigClaim.color,
          legend: count + " " + chartConfigClaim.label,
          ariaLabel: this.arialabel,
        };

        this.progressChartData.push(claimMerge);
      }
      let arr = [];
      let arr4 = this.progressChartData.filter(
        (x) =>
          x.legend.indexOf("claimed") > -1 &&
          x.legend.indexOf("not claimed") < 0
      );
      if (arr4.length > 0) {
        arr.push(arr4.pop());
      }
      let arr3 = this.progressChartData.filter(
        (x) =>
          x.legend.indexOf("claim pending") > -1 &&
          x.legend.indexOf("unclaim pending") < 0
      );
      if (arr3.length > 0) {
        arr.push(arr3.pop());
      }
      let arr2 = this.progressChartData.filter(
        (x) => x.legend.indexOf("unclaim pending") > -1
      );
      if (arr2.length > 0) {
        arr.push(arr2.pop());
      }
      let arr1 = this.progressChartData.filter(
        (x) => x.legend.indexOf("not claimed") > -1
      );
      if (arr1.length > 0) {
        arr.push(arr1.pop());
      }

      this.progressChartData = arr;

      let legendCounter = 0;
      this.progressChartData.forEach((x, i) => {
        // if legendcounter is even, show legend on the left else on the right
        this.legendData[legendCounter % 2 === 0 ? "left" : "right"].push(x);
        legendCounter++;
      });
      this.rightLabel = String(totalValue);
    }
  }

  /* modal popover if support link is clicked from accordion */
  launchSupportModal(modalName) {
    this.confirmModalPopup = new ConfirmModalPopupModel();
    this.confirmModalPopup.modalSubHeader = "";
    if (modalName === "Locking a device") {
      this.manageInventoryService
        .requestPopupContent(
          this.utilityService.getEnvConfig().getSupportDocument[0]
        )
        .subscribe((res) => {
          this.confirmModalPopup.modalMessage = res.content;
        });
      this.confirmModalPopup.modalHeader =
        this.deviceInventoryData.lockingDevice;
    } else if (modalName === "Wiping a device") {
      this.manageInventoryService
        .requestPopupContent(
          this.utilityService.getEnvConfig().getSupportDocument[1]
        )
        .subscribe((res) => {
          this.confirmModalPopup.modalMessage = res.content;
        });
      this.confirmModalPopup.modalHeader =
        this.deviceInventoryData.wipingDevice;
    } else {
      this.router.navigateByUrl("/faq?id=9");
    }
    this.confirmModalPopup.confirmButtonMessage = "OK";
    this.confirmModalPopup.showCancelButton = false;
    this.initModal = true;
    this.showSupport = true;
    this.eventEmit = document.activeElement;
  }

  closeModal(confirm) {
    this.initModal = false;
    this.showSupport = false;
    this.showPopup = false;
  }

  handleError(error) {
    this.pageloaderService.setPageLoaderStatus(true);
    this.showError = true;
  }

  checkFanId() {
    this.selectedFanId = this.manageInventoryService.getSelectedFan();
    if (this.selectedFanId == null || isNaN(parseInt(this.selectedFanId))) {
      this.router.navigate(["manageInventory"]);
    } else {
      this.utilityService.setSelectedFan(this.selectedFanId);
      sessionStorage.setItem("fanID", this.selectedFanId);
    }
  }

  viewProfile() {
    this.manageInventoryService.setSelectedProfileID(
      this.data.profile.profileId
    );
    this.router.navigate(["manageInventory/fanDeploymentProfile"]);
  }
  cancelPaticipation(index) {
    let emmProductCode =
      this.deviceSummaryData[parseInt(index)].fan.emmProductCode;
    sessionStorage.setItem("emmProductCode", emmProductCode);
    if (!this.oemStatus) {
      this.router.navigate(["cancelParticipation"]);
    } else {
      sessionStorage.removeItem("removeManage");
      this.router.navigate(["cancelParticipation/removeaccount"]);
    }
  }
  dismissInfo() {
    this.smsSent = false;
    this.showNotifyError = false;
    this.showorgidsuccessmsg = false;
    this.formSuccess = false;
    this.formSuccessGrp = false;
    this.manageGroupFlag = false;
    this.groupDeviceFlag = false;
  }

  disableNavLinks(field) {
    field.disable = false;
    field.imgUrl = field.imgUrl;
    if (
      (field.fieldPermission === "deviceInventory.sendMessage" &&
        1 > JSON.parse(sessionStorage.getItem("noOfDevice"))) ||
      this.utilityService.checkFieldPermission(
        field.fieldPermission,
        this.permissions.perm
      )
    ) {
      field.disable = true;
      field.imgUrl = field.disabledImgUrl;
    }
  }

  disableReportIconIfABMFEPending(field) {
    this.disableLinks = true;
    field.disable = false;
    //if (field.fieldPermission === "deviceInventory.reports" || field.fieldPermission === "deviceInventory.sendMessage") {
    field.disable = true;
    field.imgUrl = field.disabledImgUrl;
    // }
  }

  // Report pop up functionality
  initReportPopupModal() {
    this.modalClass = "modal-lg";
    this.overviewModalPopup = new ConfirmModalPopupModel();
    this.showReportPopup = true;
    this.eventEmit = document.activeElement;

    this.manageInventoryService.createPageLoadProperties(
      "REQUEST_REPORTS_MODAL"
    );
  }

  closeReportPopup() {
    this.showReportPopup = false;

    this.manageInventoryService.createPageLoadProperties(
      "DEVICE_INVENTORY",
      "DeviceInventory"
    );
  }

  updateExistingDate(index) {
    let fanId = this.singleFanInventory.fan;
    let minDate = new Date();
    this.existingDate = this.dateformatter.formatDate(
      "yyyy-mm-dd",
      new Date(minDate.getFullYear(), minDate.getMonth(), minDate.getDate() + 1)
    );
    let checkdata = {
      fan: fanId,
      existingDate: this.existingDate,
      productCode: this.deviceSummaryData[index].fan.emmProductCode,
    };
    this.manageInventoryService.postExistingDate(checkdata).subscribe((res) => {
      if (res.status === "success") {
        this.formSuccess = true;
        this.enrollStatusArr[parseInt(index)] = false;
      } else {
        this.failuremessage = true;
        this.showError = true;
      }
    }),
      (error) => {
        this.failuremessage = true;
      };
  }

  selectedProfile() {
    let profileId = this.singleFanInventory.profileId;
    this.manageInventoryService.setSelectedProfileID(profileId);
    let notificationcomstatus = this.data.profile.communicationPref
      ? this.singleFanInventory.comPref
      : "";
    this.manageInventoryService.Deviceinventorynotifystatus(
      notificationcomstatus
    );
  }
  selectedFan(value) {
    let fan = this.singleFanInventory.fan;
    this.manageInventoryService.deviceinventoryselectedfan(fan);
    //let deviceinventoryorgId = this.singleFanInventory.emmAccId;
    this.manageInventoryService.deviceinventoryselectedorgid(value);
    this.router.navigate(["manageInventory/manageAccounts"]);
  }
  ngAfterViewInit() {
    this.showNotifyMsg = sessionStorage.getItem("resSuccess");
    if (this.showNotifyMsg === "true") {
      this.showNotifyError = true;
    } else if (this.showNotifyMsg === "false") {
      this.showNewnotifyFailureError = true;
    }
    sessionStorage.removeItem("resSuccess");

    this.showorgidsuccessMsg = sessionStorage.getItem("resorgidSuccess");
    if (this.showorgidsuccessMsg === "true") {
      this.showorgidsuccessmsg = true;
    } else if (this.showorgidsuccessMsg === "false") {
      this.showorgidFailError = true;
    }
    sessionStorage.removeItem("resorgidSuccess");

    //handle success messgae for move group devices
    if (sessionStorage.getItem("reviewGrpSuccess") == "true") {
      this.formSuccessGrp = true;
    } else {
      this.formSuccessGrp = false;
    }
    sessionStorage.removeItem("reviewGrpSuccess");
  }

  continueManageGroup() {
    if (this.countFlag) {
      this.manageGroupFlag = true;
    } else {
      this.router.navigate(["/manageGroups"]);
    }
  }

  // getGroupingDevicesData() {
  //   var sessionId = sessionStorage.getItem("sessionId");
  //   this.manageInventoryService
  //     .getGroupDevicesData(this.selectedFanId, sessionId)
  //     .subscribe(
  //       (resposneObject) => {
  //         var response = JSON.parse(JSON.stringify(resposneObject));
  //         sessionStorage.setItem(
  //           "groupDeviceTableData",
  //           JSON.stringify(response)
  //         );
  //         this.getFanStatusAndGroupsData();
  //       },
  //       (error) => {
  //         this.handleError(error);
  //       }
  //     );
  //   }
    // Code for accessories icon
    gotoAccesories() {
      let url= this.utilityService.getEnvConfig().accessoriesLink;
      //to get FAN Name
      // console.log("Fan Number : ",this.singleFanInventory.fan);
      // const fansList = JSON.parse(sessionStorage.getItem("user")).user.fans;
      // const selectedFanDetail = fansList.filter((fan:any) => {
      //   return fan.fanId === this.singleFanInventory.fan;
      // });
      // const selectedFanName = selectedFanDetail[0].fanName;
      // console.log("Fan Name : ", selectedFanName);

      //to get imei and ctn
      // console.log("-------this.ctnTable", this.ctnTable);
      // var sessionId = sessionStorage.getItem("sessionId");
      // // this.ctn = this.ctnTable.list[0].ctnNumber;
      // // this.imei = this.ctnTable.list[0].imei;
      // var randomIndex = Math.floor(Math.random() * this.ctnTable.list.length);
      // this.ctn = this.ctnTable.list[randomIndex].ctnNumber;
      // this.imei = this.ctnTable.list[randomIndex].imei;
      // console.log('Random CTN:', this.ctn);
      // console.log('Random IMEI:', this.imei);

      //to get utm parameters
      const utmSource = 'DMP device inventory'; 
      const utmMedium = 'icon'; 
      const utmCampaign = 'device accessory showcase'; 
      this.adobeAnalyticsService.createClickProperties('Device Inventory Purchase accessories', 'body', '/business/shop/shop_cru_home.jsp');

      // Append all parameters to the URL
      const trackedUrl = `${url}?utm_source=${utmSource}&utm_medium=${utmMedium}&utm_campaign=${utmCampaign}`;
      // Navigate to the tracked URL
      window.open(trackedUrl, '_blank');
    }
  }